document.addEventListener("DOMContentLoaded", function () {
  // Attach click event listeners to each tab link
  var tabLinks = document.querySelectorAll(".tablinks");
  tabLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      openCity(event);
    });
  });

  // Activate the first tab in each group
  var tabGroups = document.querySelectorAll("[data-tab-group]");
  tabGroups.forEach(function (group) {
    var firstTab = group.querySelector(".tablinks");
    if (firstTab) {
      firstTab.click(); // Simulate a click on the first tab to activate it
    }
  });
});

function openCity(evt) {
  var i, tabcontent, tablinks;
  var tabGroup = evt.currentTarget.parentElement.getAttribute("data-tab-group");
  var target = evt.currentTarget.getAttribute("data-target");

  tabcontent = document.querySelectorAll(
    `[data-content-group="${tabGroup}"] [data-content]`
  );
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  tablinks = document.querySelectorAll(
    `[data-tab-group="${tabGroup}"] .tablinks`
  );
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  document.querySelector(
    `[data-content-group="${tabGroup}"] [data-content="${target}"]`
  ).style.display = "block";
  evt.currentTarget.className += " active";
}

var swiper = new Swiper(".tabsProducts", {
  grabCursor: true,
  slidesOffsetAfter: 40,
  freeMode: true,
  direction: "horizontal",
  mousewheel: {
    forceToAxis: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});
